import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {DESKTOP_STICKY_HEIGHT} from '../../backend-services/Header/constants';

export const NavigationTreeLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <div className={className} style={style}>
      <SkeletonBlock
        $width="120%"
        $height="22px"
        style={{marginTop: DESKTOP_STICKY_HEIGHT}}
      />
      <SkeletonBlockIndented $width="70%" $height="18px" />
      <SkeletonBlockIndented $width="80%" $height="18px" />
      <SkeletonBlockIndented $width="70%" $height="18px" />
      <SkeletonBlockIndented $width="80%" $height="18px" />
      <SkeletonBlockIndented $width="70%" $height="18px" />
      <SkeletonBlockIndented $width="80%" $height="18px" />
      <SkeletonBlock $width="120%" $height="22px" />
      <SkeletonBlock $width="120%" $height="22px" />
      <SkeletonBlock $width="120%" $height="22px" />
      <SkeletonBlock $width="120%" $height="22px" />
      <SkeletonBlock $width="120%" $height="22px" />
    </div>
  );
};

const SkeletonBlockIndented = styled(SkeletonBlock)`
  margin-left: 1rem;
`;
